(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('multipleUploadTrackEventsService', multipleUploadTrackEventsService);

    multipleUploadTrackEventsService.$inject = ['googleTagManagerService', '_'];

    function multipleUploadTrackEventsService(googleTagManagerService, _) {

        var service = {
            trackFilesDropped: trackFilesDropped,
            trackBrowseFiles: trackBrowseFiles,
            trackAddPreviouslyUploadedModels: trackAddPreviouslyUploadedModels,
            trackAddToCart: trackAddToCart,
            trackRequestPrice: trackRequestPrice,
            trackAcceptDeclineV3RepairResults: trackAcceptDeclineV3RepairResults
        };

        return service;

        // --------------------------------------------------------------------------------------------------

        function trackFilesDropped(files) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Upload New Model',
                'eventAction': 'Multiple Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Multiple Upload Page - Drag and Drop',
                'eventLabel': 'Amount of files: ' + files.length,
                'eventValue': undefined
            });
        }

        function trackBrowseFiles(files) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Upload New Model',
                'eventAction': 'Multiple Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Upload Control',
                'eventAction': 'Multiple Upload Page - File Select Control',
                'eventLabel': 'Amount of files: ' + files.length,
                'eventValue': undefined
            });
        }

        function trackAddPreviouslyUploadedModels(modelIds) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Add Uploaded Model',
                'eventAction': 'Multiple Upload Page',
                'eventLabel': undefined,
                'eventValue': undefined
            });
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Use Uploaded Model Control',
                'eventAction': 'Multiple Upload Page - Add Uploaded Model from Popup',
                'eventLabel': 'Amount of models: ' + modelIds.length,
                'eventValue': undefined
            });
        }

        function trackAddToCart(products) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Funnel] Add Model to Cart',
                'eventAction': 'Multiple Upload Page',
                'eventLabel': 'Amount of products: ' + products.length,
                'eventValue': undefined
            });
        }

        function trackRequestPrice(products) {
            trackPriceRequestByIssueType(products, 'InvalidModel', 'Invalid Model');
            trackPriceRequestByIssueType(products, 'ProcessingFailed', 'Processing Failed');
            trackPriceRequestByIssueType(products, 'NoOnlinePrice', 'No Online Price');
            trackPriceRequestByIssueType(products, 'PriceLimit', 'Price Limit');
        }
        
        function trackAcceptDeclineV3RepairResults(isAccepted) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Aggressive repair results',
                'eventAction': 'Multiple Upload Page',
                'eventLabel': isAccepted ? 'Accepted' : 'Declined',
                'eventValue': undefined
            });
        }

        function trackPriceRequestByIssueType(products, issueType, eventActionLabel) {
            var productsCount = getProductsWithIssueCount(products, issueType);
            if (productsCount > 0) {
                var eventData = {
                    'event': 'imat.event',
                    'eventCategory': '[Interaction - Tracking] Proceed to Offline Price Request',
                    'eventAction': 'Multiple Upload Page - ' + eventActionLabel,
                    'eventLabel': 'Amount of products: ' + productsCount,
                    'eventValue': undefined
                };
                googleTagManagerService.pushToDataLayer(eventData);
            }
        }

        function getProductsWithIssueCount(products, issueType) {
            return _.filter(products, function (product) {
                return product.issue.type === issueType;
            }).length;
        }
    }
})();